<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        :class="twClass"
    >
        <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 19.5L8.25 12l7.5-7.5"
        />
    </svg>
</template>

<script setup lang="ts">
const {twClass = 'w-6 h-6 stroke-1 stroke-primary'} = defineProps<{ twClass?: string }>();
</script>
